import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    { icon: 'ri-lightbulb-flash-line', titleKey: 'services.svc1.title', descKey: 'services.svc1.desc', color: 'bg-amber-50', iconColor: 'text-amber-500', borderColor: 'border-amber-100' },
    { icon: 'ri-building-2-line', titleKey: 'services.svc2.title', descKey: 'services.svc2.desc', color: 'bg-orange-50', iconColor: 'text-orange-500', borderColor: 'border-orange-100' },
    { icon: 'ri-line-chart-line', titleKey: 'services.svc3.title', descKey: 'services.svc3.desc', color: 'bg-green-50', iconColor: 'text-green-600', borderColor: 'border-green-100' },
    { icon: 'ri-settings-3-line', titleKey: 'services.svc4.title', descKey: 'services.svc4.desc', color: 'bg-sky-50', iconColor: 'text-sky-500', borderColor: 'border-sky-100' },
    { icon: 'ri-global-line', titleKey: 'services.svc5.title', descKey: 'services.svc5.desc', color: 'bg-violet-50', iconColor: 'text-violet-500', borderColor: 'border-violet-100' },
    { icon: 'ri-customer-service-2-line', titleKey: 'services.svc6.title', descKey: 'services.svc6.desc', color: 'bg-rose-50', iconColor: 'text-rose-500', borderColor: 'border-rose-100' },
  ];

  return (
    <section id="services" className="bg-white py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-5">
            <span className="w-1 h-1 bg-amber-500 rounded-full" />
            <span className="text-amber-600 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('services.badge')}</span>
          </div>
          <h2 className="text-gray-900 text-4xl md:text-5xl font-bold mb-4 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            {t('services.heading1')}<br />
            <span className="text-amber-500">{t('services.heading2')}</span>
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{t('services.desc')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc, idx) => (
            <div key={idx} className={`group bg-white border ${svc.borderColor} rounded-2xl p-7 hover:border-amber-300 transition-all duration-300 cursor-default`} style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
              <div className={`w-13 h-13 w-14 h-14 flex items-center justify-center ${svc.color} rounded-xl mb-5 transition-colors duration-300`}>
                <i className={`${svc.icon} ${svc.iconColor} text-2xl`} />
              </div>
              <h3 className="text-gray-900 font-bold text-base mb-3 leading-snug" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t(svc.titleKey)}</h3>
              <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{t(svc.descKey)}</p>
              <div className="mt-5 flex items-center gap-1.5 text-amber-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="text-xs font-semibold tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('services.moreInfo')}</span>
                <i className="ri-arrow-right-line text-sm" />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white text-xl md:text-2xl font-bold mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('services.bannerTitle')}</h3>
            <p className="text-white/80 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>{t('services.bannerSubtitle')}</p>
          </div>
          <Link to="/urunler" className="flex-shrink-0 bg-white hover:bg-amber-50 text-amber-600 font-bold px-7 py-3.5 rounded-full text-sm tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            {t('services.viewProducts')}
          </Link>
        </div>
      </div>
    </section>
  );
}